/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _slicedToArray } from '../../_chunks/dep-e43cf21c.js';
import { useCallback } from 'react';
import useControlled from '../../hooks/useControlled.js';
import '../../_chunks/dep-2acfafca.js';
import '../../_chunks/dep-f721d103.js';
import '../../_chunks/dep-c3f1141e.js';
import '../../_chunks/dep-4559db64.js';
import '../../_chunks/dep-c00532d4.js';
import '../../_chunks/dep-33ffecad.js';
import '../../_chunks/dep-4941ebe7.js';
import '../../_chunks/dep-e9b62d1f.js';
import '../../_chunks/dep-77e34309.js';
import '../../_chunks/dep-c1f93350.js';
import '../../_chunks/dep-7dce2c26.js';
import '../../_util/noop.js';

var useIndex = function useIndex(resProps, images) {
  var _useControlled = useControlled(resProps, "index", resProps.onIndexChange),
    _useControlled2 = _slicedToArray(_useControlled, 2),
    index = _useControlled2[0],
    setIndex = _useControlled2[1];
  var next = useCallback(function () {
    var newIndex = index + 1;
    if (newIndex >= images.length) return index;
    setIndex(newIndex, {
      trigger: "next"
    });
  }, [setIndex, index, images.length]);
  var prev = useCallback(function () {
    var newIndex = index - 1 > 0 ? index - 1 : 0;
    setIndex(newIndex, {
      trigger: "prev"
    });
  }, [index, setIndex]);
  return {
    index: index,
    next: next,
    prev: prev,
    setIndex: setIndex
  };
};

export { useIndex as default };
//# sourceMappingURL=useIndex.js.map
